// components/button/IconButtonBase.tsx
import { IconButton, IconButtonProps } from "@mui/material";

export const IconButtonBase: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props} />
);

export default IconButtonBase;